import { SelectItem } from 'Util/Helpers/Input';

export const ENDORSED_PLUMBER_CODE = 'SCEP';
export const ENDORSED_DRAINLAYER_CODE = 'SCED';

export const ENDORSEMENT_TYPE_LABELS: ReadonlyMap<string, string> = new Map([
   [ENDORSED_PLUMBER_CODE, 'Endorsed Plumber'],
   [ENDORSED_DRAINLAYER_CODE, 'Endorsed Drainlayer'],
]);

export const ENDORSEMENT_TYPE_SEARCH_OPTIONS: SelectItem[] = [
   { label: 'Select Endorsement Type', value: ' ' },
   { label: 'Endorsed Plumber', value: ENDORSED_PLUMBER_CODE },
   { label: 'Endorsed Drainlayer', value: ENDORSED_DRAINLAYER_CODE },
];
